export default __webpack_public_path__ + "static/media/acm.db2e46c0.jpg";